
import { MaintenanceAspectMetadataBase } from './maintenance-aspect.metadata.base';


export class MaintenanceAspectMetadata extends MaintenanceAspectMetadataBase {
  constructor() {
    super();
  }
}

export const MAINTENANCE_ASPECT_METADATA: MaintenanceAspectMetadata = new MaintenanceAspectMetadata();


